import api from "../api";
import {
  AdminSignInDto,
  SendFirstAccessCodeDto,
  SendRecoverPasswordCodeDto,
  UserCreateNewPasswordDto,
  VerifyFirstAccessCodeDto,
  VerifyRecoverPasswordCodeDto,
} from "../dto/admin-auth";
import { AdminCreateNewPasswordPayload, AdminSignInResponse } from "../response/admin-auth";

export const ADMIN_AUTH_ENDPOINTS = {
  SIGN_IN: "/v1/admin/auth/signin",
  REFRESH: "/v1/admin/auth/refresh",
  SEND_RECOVERY: "/v1/admin/auth/forgot-password",
  VERIFY_RECOVERY: "/v1/admin/auth/verify-code",
  SEND_FIRST_ACCESS: "/v1/admin/auth/resend-first-access-code",
  VERIFY_FIRST_ACCESS: "/v1/admin/auth/verify-first-access-code",
  NEW_PASSWORD: "/v1/admin/auth/new-password",
};

export const AdminAuthService = {
  signIn: async (data: AdminSignInDto): Promise<AdminSignInResponse> => {
    const response = await api.post(ADMIN_AUTH_ENDPOINTS.SIGN_IN, data);
    return response.data;
  },

  refresh: async (refreshToken: string): Promise<AdminSignInResponse> => {
    const response = await api.post(ADMIN_AUTH_ENDPOINTS.REFRESH, undefined, {
      headers: { Authorization: `Bearer ${refreshToken}` },
    });
    return response.data;
  },

  sendRecoveryCode: async (data: SendRecoverPasswordCodeDto): Promise<void> => {
    const response = await api.post(ADMIN_AUTH_ENDPOINTS.SEND_RECOVERY, data);
    return response.data;
  },

  verifyRecoveryCode: async (data: VerifyRecoverPasswordCodeDto): Promise<void> => {
    const response = await api.post(ADMIN_AUTH_ENDPOINTS.VERIFY_RECOVERY, data);
    return response.data;
  },

  sendFirstAccessCode: async (data: SendFirstAccessCodeDto): Promise<void> => {
    const response = await api.post(ADMIN_AUTH_ENDPOINTS.SEND_FIRST_ACCESS, data);
    return response.data;
  },

  verifyFirstAccessCode: async (data: VerifyFirstAccessCodeDto): Promise<void> => {
    const response = await api.post(ADMIN_AUTH_ENDPOINTS.VERIFY_FIRST_ACCESS, data);
    return response.data;
  },

  newPassword: async (data: UserCreateNewPasswordDto): Promise<AdminCreateNewPasswordPayload> => {
    const response = await api.post(ADMIN_AUTH_ENDPOINTS.NEW_PASSWORD, data);
    return response.data;
  },
};
